import React from 'react'
import { Text, VStack, Link as ChakraLink } from '@chakra-ui/react'
import { ExternalLinkIcon } from '@chakra-ui/icons'
import { Research } from '../../../../types/Research'

interface ResearchPublicationInfoProps {
  research: Research
}

const ResearchPublicationInfo: React.FC<ResearchPublicationInfoProps> = ({
  research,
}) => {
  return (
    <VStack align='start' spacing={4}>
      {/* Publication Info */}
      <Text color='gray.600'>
        {research.journal} • Published: {research.publicationYear}
      </Text>

      {/* External Links */}
      <VStack align='start' spacing={2}>
        <ChakraLink
          href={research.url}
          isExternal
          color='blue.500'
          fontSize='lg'
          fontWeight='semibold'
          display='flex'
          alignItems='center'
        >
          View Full Article <ExternalLinkIcon ml={2} />
        </ChakraLink>
        {research.doi && (
          <ChakraLink
            href={`https://doi.org/${research.doi}`}
            isExternal
            color='blue.500'
            fontSize='md'
            display='flex'
            alignItems='center'
          >
            DOI: {research.doi} <ExternalLinkIcon ml={1} />
          </ChakraLink>
        )}
      </VStack>
    </VStack>
  )
}

export default ResearchPublicationInfo
